import React, { useState, useEffect, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import "./ForgotPassword.css";
import closeIcon from "../assets/Close-icon.png";

import { server, Origin } from "../server";
import axios from "axios";
import { Company_Id } from "../Helper";
import { Corporate_Id } from "../Helper";
import { Corporate_Name } from "../Helper";
import { Vendor_Id } from "../Helper";
import { Vendor_Name } from "../Helper";

function Login() {
  // console.log('Version-'+axios.VERSION);
  //local details-----------------
  //  const Corporate_ID = 13611;
  //  const Corporate_Name = 'O3MPLRetail';
  //  const Vendor_Id = 2584;
  //  const Vendor_Name = 'O3MPL';
  // local details -----------------

  localStorage.setItem("isLogin", false);
  localStorage.removeItem("isLogin");
  localStorage.removeItem("userid");
  localStorage.removeItem("userName");
  localStorage.removeItem("emailId");
  localStorage.removeItem("contactNo");

  // CompanyId: "13996",
  // CorporateId: "13647",
  // CorporateName: "O3MPLRetail",
  // VendorId: "2587",
  // VendorName:"O3MPL",
  //========== Local======================
  // CorporateId: "13611",
  // CorporateName: "O3MPLRetail",
  // VendorId:"2584",
  // VendorName:"O3MPL"

  // const initialValues = {
  //   MobileNo: "", UserPass: "",
  //   CorporateId: _corporateId,
  //   CorporateName: _corporatename,
  //   VendorId: _vendorId,
  //   VendorName: _vendorName

  // }

  const [formvalue, setFormValue] = useState({
    MobileNo: "",
    UserPass: "",
    CompanyId: "13996",
    CorporateId: "13647",
    CorporateName: "O3MPLRetail",
    VendorId: "2587",
    VendorName: "O3MPL",
  });
  const [formErrors, setFormErrors] = useState({});
  const [IsSubmit, setIsSubmit] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [mobileNumber, setMobileNumber] = useState(""); // State variable


  const handChange = (e) => {
    const { name, value } = e.target;
  
    
    if (/^\d{0,10}$/.test(value)) {
      setFormValue((prev) => ({
        ...prev,
        [name]: value, 
      }));
    }
  };
  

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validate(formvalue));
    setIsSubmit(true);
  };


  // useEffect(() => {
  //   if (Object.keys(formErrors).length == 0 && IsSubmit) {
  //     // console.log(formvalue);
  //     userLogin(formvalue);
  //   }
  // }, [formErrors]);


  function validateMobileNo(mobileNo) {
    const mobileNoPattern = /^[0-9]{10}$/; // Adjust the pattern as needed
    return mobileNoPattern.test(mobileNo);
  }

  const validate = (value) => {
    const errors = {};
    if (!value.MobileNo) {
      errors.MobileNo = "Mobile No is required";
    }
    if (!validateMobileNo(value.MobileNo)) {
      errors.MobileNo = "Mobile No is not valid";
    }

  
    return errors;
  };

  const handleOtpChange = (e, index) => {
    const newOtp = [...otp];
    newOtp[index] = e.target.value;
    setOtp(newOtp);

    // Move focus to the next input field
    if (e.target.value && index < otp.length - 1) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };


  const handleResendOtp = async () => {
      handleLogin(); // Resend OTP by calling handleLogin again
    };

  const encodeMobileNumber = (mobileNo) => {
    return btoa(mobileNo); 
  };

 

  async function userLogin(formvalue) {
    try {
        // Log the raw mobile number and OTP before sending the request
        console.log("MobileNo (Raw):", formvalue.MobileNo);
        console.log("Otp (Raw):", formvalue.Otp);

        // Make the POST request to verify the OTP
        let result = await fetch(`${server}/api/O3Mobility/O3loginweb`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "text/plain",
            },
            body: JSON.stringify({
              MobileNo: formvalue.MobileNo,  
              UserPass: formvalue.Otp,            
                CompanyId: "13996",
                CorporateId: "13647",
                CorporateName: "O3MPLRetail",
                VendorId: "2587",
                VendorName: "O3MPL",
            }),
        });

        result = await result.json(); // Parse the JSON response
        console.log("Login Response:", result);

        // Handle successful login response
        if (result.statusCode === 200 && result.statusMessage === "Login Successfully") {
            localStorage.setItem("isLogin", true);
            localStorage.setItem("userid", result.userId);
            localStorage.setItem("userName", result.userName);
            localStorage.setItem("emailId", result.emailId);
            localStorage.setItem("contactNo", result.contactNo);
            localStorage.setItem("Token", result.token);

            // Navigate to the booking page
            navigate("/Booking");
        } 
        // Handle invalid login case
        else if (result.statusCode === 100 && result.statusMessage === "Invalid Login") {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Invalid Login !!",
            });
        }
    } catch (error) {
        console.error("OTP Verification Error:", error);

        // Handle error cases
        Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong. Please try again later.",
        });
    }
}

  



  const handleLogin = async () => {
    try {
      // Encode the mobile number before sending
      const encodedMobileNo = encodeMobileNumber(formvalue.MobileNo);
      const formValue = { MobileNo: encodedMobileNo }; // Send encoded mobile number
  
      let response = await fetch(`${server}/api/O3Mobility/GenerateOtp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formValue),
      });
  
      const data = await response.json();
      console.log("OTP Generation Response:", data);
  
      if (data.statusCode === 200 && data.statusMessage === "OTP Sent Successfully") {
        setShowPopup(true); // Show modal
        setShowOtp(true); // Enable OTP entry
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.statusMessage || "Failed to send OTP.",
        });
      }
    } catch (error) {
      console.error("OTP Generation Error:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong. Please try again later.",
      });
    }
  };
  
  

  return (
    <div className="hold-transition login-page">
      <div className="login-box">
        <div className="card card-outline card-warning">
          <div className="card-header text-center">
            <img
              src="/dist/img/logo.webp"
              alt="logo"
              style={{ width: "250px" }}
            />
          </div>
          <div className="card-body">
            <p className="login-box-msg">Sign in to start your session</p>

            <form onSubmit={handleSubmit}>

              
              <div className="input-group mb-3">
                <input
                  name="MobileNo"
                  type="number"
                  className="form-control"
                  placeholder="Contact No"
                  value={formvalue.MobileNo}
                  onChange={handChange}
                  maxLength={10}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-mobile" />
                  </div>
                </div>
              </div>
              <p className="text-danger">{formErrors.MobileNo}</p>

            

              {/* <p className="text-danger">{formErrors.UserPass}</p> */}

              <div className="row">
                {/* <div className="col-8">
                  <div className="icheck-primary">
                    <input type="checkbox" id="remember" />
                    <label htmlFor="remember">
                      Remember Me
                    </label>
                  </div>
                </div> */}

                <div className="col-12">
                  <button className="btn btn-warning btn-block"  onClick={handleLogin}>Login</button>
                  {/* <Link to="/Dashboard" className="btn btn-warning btn-block">Sign In</Link> */}
                </div>



              </div>
            </form>

            {showPopup && showOtp && (
  <>
    <div className="modal-overlay" onClick={() => setShowPopup(false)}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <img
          src={closeIcon}
          alt="Close"
          className="close-icon"
          onClick={() => setShowPopup(false)}
        />
        <h5>Confirm OTP</h5>
        <hr />
        <center>
          <p>
            <strong>Enter the OTP sent to your mobile number:</strong>
          </p>
          <p className="otp-mobile-number">{"xxxxxx" + formvalue.MobileNo.slice(-4)}</p>
        </center>
        <div className="otp-input-container">
          {otp.map((digit, index) => (
            <input
              key={index}
              id={`otp-input-${index}`}
              type="text"
              value={digit}
              onChange={(e) => handleOtpChange(e, index)}
              maxLength="1"
              className="otp-input-box"
            />
          ))}
        </div>
        <div className="modal-buttons">
          <center>
            <button
              className="upload-button"
              onClick={() => {
                const otpValue = otp.join("");
                const updatedFormValue = { ...formvalue, Otp: otpValue };
                userLogin(updatedFormValue); // Call userLogin with the correct payload
            }}
            
            >
              Confirm
            </button>
          </center>
        </div>
        <center>
          <p className="resend-otp">
            Didn’t receive OTP?{" "}
            <span onClick={handleResendOtp} className="resend-link">
              Resend OTP
            </span>
          </p>
        </center>
      </div>
    </div>
  </>
)}


            <div className="social-auth-links text-center mt-2 mb-3"></div>

            <div>
              <p className="mb-0" style={{ float: "left" }}>
                <Link to="/Registration" className="text-center text-danger">
                  Register Now
                </Link>
                {/* <a href="register.html" className="text-center text-danger">Register now</a> */}
              </p>

           

            </div>
          </div>
        </div>
      </div>
      <div>
        <Link
          to="/RefundPolicy"
          target="_blank"
          className="text-center text-danger"
          style={{ fontSize: "12px", color: "#5b5b55 !important" }}
        >
          Privacy Policy
        </Link>
        {/* <Link to="https://sites.google.com/view/eveelzgroundstaffprivacypolicy/home" target='_blank' className="text-center text-danger" style={{fontSize:'12px', color:'#5b5b55 !important'}}>Privacy Policy</Link> */}
      </div>
    </div>
  );
}

export default Login;
